import React from 'react';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { Hero } from './components/sections/Hero';
import { ParaTi } from './components/sections/ParaTi';
import { Isla } from './components/sections/Isla';
import { Nudos } from './components/sections/Nudos';
import { Ascender } from './components/sections/Ascender';
import { Elementos } from './components/sections/Elementos';
import { Akalki } from './components/sections/Akalki';
import { Ritmo } from './components/sections/Ritmo';
import { Frecuencia } from './components/sections/Frecuencia';
import { Desatar } from './components/sections/Desatar';
import { Detalles } from './components/sections/Detalles';
import { Facilitadoras } from './components/sections/Facilitadoras';
import { Inversion } from './components/sections/Inversion';
export function App() {
  return <div className="w-full min-h-full font-body" style={{
    backgroundColor: 'var(--cream)',
    color: 'var(--ink)'
  }} data-id="element-0" data-mp="28sbe9bxjfjac">
      <Header data-id="element-1" data-mp="3iiwfuqnezm4a" />
      <main data-id="element-2" data-mp="3ijfw82xf22g7">
        <Hero data-id="element-3" data-mp="3ijpet5g4t7bv" />
        <ParaTi data-id="element-4" data-mp="3ii4r9zs8ioni" />
        <Isla data-id="element-5" data-mp="3mlaxx8j9ehui" />
        <Nudos data-id="element-6" data-mp="3mkrdnl64zhdb" />
        <Ascender data-id="element-7" data-mp="3mkhofzsx1e8o" />
        <Elementos data-id="element-8" data-mp="3mjq1fdddwou0" />
        <Akalki data-id="element-9" data-mp="3mj6hjr46bqdc" />
        <Ritmo data-id="element-10" data-mp="3rcj5s04xxv5k" />
        <Frecuencia data-id="element-11" data-mp="3rbrcwx2qabiz" />
        <Desatar data-id="element-12" data-mp="3rdkisa5iorpx" />
        <Detalles data-id="element-13" data-mp="3rd1all5o5hp3" />
        <Facilitadoras data-id="element-14" data-mp="3relu8fqg3g86" />
        <Inversion data-id="element-15" data-mp="5opww5kum4f" />
      </main>
      <Footer data-id="element-16" data-mp="4n5i12o8na1" />
    </div>;
}